import { render, staticRenderFns } from "./examsBasicDetails.html?vue&type=template&id=0dd85786&scoped=true&external"
import script from "./examsBasicDetails.vue?vue&type=script&lang=js"
export * from "./examsBasicDetails.vue?vue&type=script&lang=js"
import style0 from "./examsBasicDetails.css?vue&type=style&index=0&id=0dd85786&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd85786",
  null
  
)

export default component.exports